import { render, staticRenderFns } from "./FeesDeleter.vue?vue&type=template&id=38e46ebc&scoped=true"
import script from "./FeesDeleter.vue?vue&type=script&lang=js"
export * from "./FeesDeleter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e46ebc",
  null
  
)

export default component.exports